import styled from 'astroturf/react'
import _Marker from "Marker.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_date_time/marker.js?styleId=Marker";

const colorAccentGreenMedium = 'var(--colorAccentGreenMedium, var(--coreColorGreen500))'

const Marker = /*#__PURE__*/styled('div', null, {
  displayName: "Marker",
  styles: _Marker
})

export default Marker
